<template>
  <v-data-table
    :headers="headers"
    :items="items"
    :fixed-header="true"
    :disable-pagination="true"
    :loading="$apollo.loading"
    :height="tableHeight"
    :search="search"
    :sort-by="sortBy"
    loading-text="Laddar... var god vänta!"
    no-data-text="Ingen data..."
    no-results-text="Inget resultat på din sökning..."
    hide-default-footer
    @click:row="onClickRow"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-menu
          ref="dateMenu"
          v-model="showDateMenu"
          :return-value.sync="filterPeriod"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              :value="
                isDateFilter ? `${filterPeriod[0]} ~ ${filterPeriod[1]}` : null
              "
              filled
              placeholder="Filtrera på period"
              rounded
              dense
              single-line
              hide-details
              clearable
              @click:append="showDateMenu = true"
              @click:clear="filterPeriod = []"
              append-icon="mdi-calendar-range"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            locale="sv"
            first-day-of-week="1"
            range
            v-model="filterPeriod"
            no-title
            scrollable
          >
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="showDateMenu = false"
              >Avbryt</v-btn
            >
            <v-btn
              text
              color="primary"
              @click="$refs.dateMenu.save(filterPeriod)"
              >OK</v-btn
            >
          </v-date-picker>
        </v-menu>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Sök..."
          single-line
          hide-details
          rounded
          filled
          dense
        ></v-text-field>
        <v-spacer />
        <v-btn @click="exportExcel" rounded>
          Exportera till Excel
          <v-icon small right>mdi-file-export-outline</v-icon>
        </v-btn>
      </v-toolbar>
    </template>

    <template v-slot:item.is_matched="{ item }">
      <v-icon class="checked" v-if="item.is_matched">mdi-check-circle</v-icon>
    </template>
  </v-data-table>
</template>

<script>
import GET_LOST_PROPERTIES from '@/gql/lostProperties/queries/GetLostProperties.gql'
import { tableHeight } from '@/mixins/tableHeight'
import { format, isWithinInterval, startOfDay, endOfDay } from 'date-fns'
import { get } from 'vuex-pathify'
import { exportExcel } from '@/services/export-excel-service.js'
import orderBy from 'lodash.orderby'

export default {
  name: 'LostProperties',

  mixins: [tableHeight()],

  data() {
    return {
      showDateMenu: false,
      filterPeriod: [],
      formTitle: 'Upphittade föremål',
      lostProperties: [],
      headers: [
        { text: 'Match', value: 'is_matched' },
        { text: 'Upphittad tid', value: 'found_at' },
        { text: 'Skapad av', value: 'created_by.email' },
        { text: 'Kategori', value: 'category.category_group.name' },
        { text: 'Underkategori', value: 'category.name' },
        { text: 'Beskrivning', value: 'description' },
        { text: 'Färdsätt', value: 'transportation_type.name' },
        { text: 'Linje/tågnummer', value: 'transportation_number' },
        {
          text: 'Sträcka (till/från station eller hållplats)',
          value: 'transportation_information',
        },
      ],
      search: '',
      sortBy: 'id',
    }
  },

  apollo: {
    lostProperties: {
      query: GET_LOST_PROPERTIES,
    },
  },

  computed: {
    owner: get('app/owner'),

    items() {
      return this.lostProperties
        .filter(
          x =>
            !this.isDateFilter ||
            isWithinInterval(new Date(x.found_at), {
              start: startOfDay(new Date(this.sortedFilterPeriod[0])),
              end: endOfDay(new Date(this.sortedFilterPeriod[1])),
            }),
        )
        .map(x => ({
          ...x,
          found_at: format(new Date(x.found_at), 'yyyy-MM-dd HH:mm'),
        }))
        .filter(x => !x.done)
    },

    isDateFilter() {
      return this.filterPeriod && this.filterPeriod.length === 2
    },

    sortedFilterPeriod() {
      if (!this.isDateFilter) return null

      return orderBy(this.filterPeriod, [x => x], ['asc'])
    },
  },

  methods: {
    onClickRow(v) {
      this.$router.push(`/${this.owner}/lost-properties/${v.uuid}`)
    },

    exportExcel() {
      const filename = `Upphittade föremål`

      const workbook = {
        name: filename,
        sheets: [
          {
            name: 'data',
            data: this.items.map(row => {
              return {
                Id: row.id,
                'Upphittad tid': row.found_at,
                'Skapad av': row.created_by.email,
                Kategori: row.category.category_group.name,
                Underkategori: row.category.name,
                Beskrivning: row.description,
                'Färdsätt.': row.transportation_type.name,
                'Linje/tågnummer.': row.transportation_number,
                'Sträcka (till/från station eller hållplats)':
                  row.transportation_information,
              }
            }),
          },
        ],
      }

      exportExcel(filename, workbook)
    },
  },
}
</script>
